import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "../../../../../../ui/TextField";

const defaultData = {
  message: ""
};

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  block: {
    margin: "35px 0 15px 0"
  },
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 12
  }
});

const Thanx = ({ disabled, onFormChange, initialData, classes, editmode }) => {
  const [data, setData] = React.useState(initialData || defaultData);
  const {message} = data;

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.heading}>Благодарность за участие</Typography>

      <TextField
        multirow
        value={message}
        onChange={e => onChange("message", e.target.value)}
        label="Сообщение участникам опроса"
        disabled={disabled}
        readOnly={!editmode}
      />
    </div>
  );
};

export default withStyles(styles)(Thanx);
